/* eslint-disable */
import axios, { AxiosResponse } from 'axios';
import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import { useDispatch, useSelector, useStore as useReduxStore } from 'react-redux';
import styles from './styles/style.module.scss';
import Plans from './layouts/plans';
import { useStore } from '../../store/store';
import { selectProducts, selectPaymentSystem } from 'core/store/billing/selectors';
import { PaymentSystem } from '@web-solutions/react-billing';
import { setupStripePayment } from 'src/onboarding/helpers/setupStripePayment';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { getLocalizedText } from 'core/utils/localized';
import { t } from '@web-solutions/module-localization';
import getLocale from '../../../localization/get-locale';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';

import { EmailPopup } from 'src/onboarding/components/ui/email-popup/EmailPopup';
import { GiftPopup } from 'src/onboarding/components/ui/gift-popup/GiftPopup';
import video from '../../assets/paywallVideo.mp4';
import paywallPoster from '../../assets/images/paywallGirl.png';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { CheckmarkIcon } from 'src/onboarding/assets/icons/CheckmarkIcon';
import { GiftIcon } from 'src/onboarding/assets/icons/GiftIcon';
import { usePayment } from 'core/payment/payment-processor-provider/paymentProcessorContext';
import { useNav } from 'src/onboarding/hooks/nav';
import { useStripeAnonymousCustomer } from 'src/onboarding/hooks/useStripeAnonymousCustomer';
import instance from 'src/onboarding/api/interceptor';
import { processEmail } from 'core/store/profile/actions';
import { attachApplePayEmailIfPresent } from 'src/onboarding/helpers/attachApplePayEmailIfPresent';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import { init } from 'core/store/billing/actions';

declare const gtag: Function;

const EMAIL_POPUP_KEY = 'email_popup_shown';
const GIFT_POPUP_KEY = 'gift_popup_shown';

interface PlansRef {
  onPayment: () => void;
}

function addDaysToDate(days: string): string {
  const daysNumber = parseInt(days, 10);
  if (isNaN(daysNumber)) {
    return '';
  }

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + daysNumber);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const formattedDate = formatter.format(currentDate);
  return formattedDate;
}

const Paywall = () => {
  const locale = getLocale();
  const childRef = useRef<PlansRef>(null);
  const pageRef = useRef(null);
  const state = useStore((state) => state);
  const { savedOnboarding, existTimeoutId } = state;
  const setPage = useStore((state) => state.setPage);
  const setEmail = useStore((state) => state.setEmail);
  const productsObj = useSelector(selectProducts);
  const reduxStore = useReduxStore();
  const {
    specialOffer,
    products,
    routeGroups: flow,
    showEmailPopup,
    showGiftPopup,
    paywall,
    paymentSystem,
    //@ts-ignore
    collectEmailAfterPayment,
  } = useRemoteConfig();

  const { ppRef, callbacksRef } = usePayment();
  const { onNext } = useNav();

  // Stripe deferred-email flow: create an anonymous Stripe customer on open so
  // checkout needs no email. No-op unless `collectEmailAfterPayment` + Stripe.
  useStripeAnonymousCustomer();

  const [showDownSaleModalOnce, setShowDownSaleModalOnce] = useState(false);
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(
    false && !sessionStorage.getItem(EMAIL_POPUP_KEY)
  );
  const [isGiftPopupOpen, setIsGiftPopupOpen] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const scrollRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    if (isEmailPopupOpen) {
      const scrollY = window.scrollY;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      return () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        window.scrollTo(0, scrollY);
      };
    }
  }, [isEmailPopupOpen]);

  useEffect(() => {
    if (showEmailPopup && !sessionStorage.getItem(EMAIL_POPUP_KEY)) {
      setIsEmailPopupOpen(true);
    } else if (showGiftPopup && !sessionStorage.getItem(GIFT_POPUP_KEY)) {
      setIsGiftPopupOpen(true);
    }
  }, []);

  const handleEmailPopupClose = () => {
    setIsEmailPopupOpen(false);
    sessionStorage.setItem(EMAIL_POPUP_KEY, 'true');

    if (showGiftPopup && !sessionStorage.getItem(GIFT_POPUP_KEY)) {
      setIsGiftPopupOpen(true);
    }
  };

  const handleGiftPopupClose = () => {
    setIsGiftPopupOpen(false);
    sessionStorage.setItem(GIFT_POPUP_KEY, 'true');
  };

  const { apiBaseUrl } = getEnvUrl();

  useEffect(() => {
    gtag('event', 'conversion', {
      send_to: 'AW-17149973324/gwbSCMu_yP0aEMym3_E_',
      value: 1.5,
      currency: 'USD',
    });

    // @ts-ignore
    window.fbq?.('track', 'CompleteRegistration');
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(existTimeoutId);
    };
  }, [existTimeoutId]);

  useEffect(() => {
    const videoEl = document.createElement('video');
    videoEl.style.display = 'none';
    videoEl.preload = 'auto';
    videoEl.muted = true;
    videoEl.src = video;

    document.body.appendChild(videoEl);

    return () => {
      if (document.body.contains(videoEl)) {
        document.body.removeChild(videoEl);
      }
    };
  }, [video]);

  console.log('products ', products);
  const productDescription = showDownSaleModalOnce
    ? {
        name: specialOffer.products[0]?.name,
        plan_end_days: addDaysToDate(specialOffer.products[0]?.plan_end_days),
        subTitle: specialOffer.products[0]?.subTitle[locale],
        title: specialOffer.products[0]?.title[locale],
        price: specialOffer.products[0]?.priceStartTrial.price,
        trialPrice: specialOffer[0]?.trialPrice,
        afterTrial: specialOffer[0]?.afterTrialText[locale],
      }
    : {
        name: products[0]?.name,
        plan_end_days: addDaysToDate(products[0]?.priceStartTrial.plan_end_days),
        subTitle: products[0]?.subTitle[locale],
        title: products[0]?.title[locale],
        price: products[0]?.priceStartTrial.price[locale],
        //@ts-ignore
        trialPrice: products[0]?.trialPrice,
        afterTrial: products[0]?.afterTrialText[locale],
      };
  const { name, plan_end_days, subTitle, title, price, trialPrice, afterTrial } =
    productDescription;

  const targetRef = useRef(null);

  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const payment = () => {
    //@ts-ignore
    callbacksRef.current = {
      onSuccess: async (data) => {
        // Apple Pay deferred-email: if the Apple Pay sheet returned an email,
        // attach it (/auth/email/attach) and skip the email-after-payment page.
        // No-op for card / Apple Pay without email — page is shown and collects it.
        await attachApplePayEmailIfPresent({ collectEmailAfterPayment, paymentSystem });
        setShowSuccessPopup(true);
        setTimeout(() => setShowCheck(true), 400);
        setTimeout(() => onNext(), 1800);
      },
      onError: (data) => console.log('error', data),
    };

    ppRef.current?.showPaymentPopup();
  };

  useEffect(() => {
    if (showEmailPopup && isEmailPopupOpen) {
      return;
    }
  }, [
    savedOnboarding,
    showEmailPopup,
    isEmailPopupOpen,
  ]);

  const formatPriceInText = (text, priceAmount) => {
    if (!text || !priceAmount) return text;

    return text.replace(/\$\d+\.\d{2}/g, `$${priceAmount}`);
  };

  // проверять сам объект бессмысленно — он всегда truthy, скрывать блок нужно по тексту
  const noPaymentText = getLocalizedText(paywall.noPayment, locale);

  const dispatch = useDispatch();

  const params = new URLSearchParams(window.location.search);
  const flowParam = params.get('flow');
  const idParam = params.get('id');
  const isSubscriptionFlow = flowParam === 'subscription';

  const subscriptionFlowInitRef = useRef(false);

  useEffect(() => {
    if (!isSubscriptionFlow || !idParam || subscriptionFlowInitRef.current) return;

    subscriptionFlowInitRef.current = true;

    const fetchEmail = async () => {
      try {
        const { data } = await instance.get(`/profile/${idParam}/email`);
        //@ts-ignore
        if (data.email) {
          setEmail(data.email);
          //@ts-ignore
          dispatch(processEmail(data.email));
          dispatch(reInitRemoteConfig());

          // Read the payment system from the store (loaded at boot) to pick the branch.
          const paymentSystem = selectPaymentSystem(reduxStore.getState());

          if (paymentSystem === PaymentSystem.STRIPE) {
            // Stripe subscription flow: the user already exists, so we don't create a
            // Stripe customer — we authorize with the token from this endpoint and
            // load subscription + onetime products + init Stripe, so the card form
            // can charge the trial (one-time-payment) and then create the subscription.
            await setupStripePayment({
              email: data.email,
              dispatch,
              paymentSystem,
              authPayload: data,
            });
          } else {
            // Non-Stripe (truegate, etc.) — original behavior.
            dispatch(init());
          }
        }
      } catch (e) {
        console.error('Failed to fetch email:', e);
      }
    };

    fetchEmail();
  }, [isSubscriptionFlow, idParam]);

  return (
    <>
      <div className={styles.page} ref={pageRef}>
        <div className={styles.videoContainer}>
          <video
            controls={false}
            autoPlay
            muted
            loop
            playsInline
            preload='auto'
            poster={paywallPoster}
          >
            <source src={video} type='video/mp4' />
          </video>
          <div className={styles.overlay}></div>
          <Typography variant='h1-bold' className={styles.title}>
            {getLocalizedText(paywall.title, locale)}
          </Typography>
        </div>
        <Typography variant='body-semibold'>
          {getLocalizedText(paywall.optionsTitle, locale)}
        </Typography>
        <div className={styles.options}>
          {paywall.options.map((option, index) => (
            <Typography key={index} variant='callout-medium' className={styles.option}>
              <CheckmarkIcon /> {getLocalizedText(option, locale)}
            </Typography>
          ))}
        </div>
        <div className={styles.trial}>
          <GiftIcon />
          <Typography variant='body-semibold'>{title}</Typography>
        </div>
        <div className={styles.price}>
          <Typography variant='h3-bold' className={styles.trialPrice}>
            {trialPrice}
          </Typography>
          <Typography variant='caption-tabBar' className={styles.afterTrial}>
            {afterTrial}
          </Typography>
        </div>
      </div>
      <div className={styles.footer}>
        {' '}
        <Plans
          ref={childRef}
          showDownSaleModalOnce={showDownSaleModalOnce}
          setShowDownSaleModalOnce={setShowDownSaleModalOnce}
          scrollToTarget={scrollToTarget}
        />
        {/* <span className={styles.privacy}>
                      {t('onboarding.personalPlan.plan.accept')}{' '}
                      <a onClick={() => setPage('privacy-policy')}>
                        {t('onboarding.personalPlan.plan.privacy')}
                      </a>
                      , <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
                    </span>
                    {showPlanDescription && (
                      <span className={styles.privacy}>
                        {t('onboarding.personalPlan.plan.planExpires')} {plan_end_days}.{' '}
                        {t('onboarding.personalPlan.plan.harged')} {subTitle}{' '}
                        {t('onboarding.personalPlan.plan.for')} {title},{' '}
                        {t('onboarding.personalPlan.plan.then')} {price}.{' '}
                        {t('onboarding.personalPlan.plan.last')}
                      </span>
                    )} */}
        {noPaymentText && (
          <div className={styles.noPayment}>
            <CheckmarkIcon />
            <Typography variant='caption-tabBar'>{noPaymentText}</Typography>
          </div>
        )}
        <div className={styles.overlay}></div>
      </div>
      <div
        className={`${styles.bottomTextContainer} ${
          !noPaymentText ? styles.bottomTextContainerNoPayment : ''
        }`}
      >
        <Typography variant='caption-tabBar' className={styles.bottomText}>
          {formatPriceInText(getLocalizedText(paywall.bottomText, locale), price)}{' '}
          <span className={styles.privacy}>
            <a onClick={() => setPage('privacy-policy')}>
              {t('onboarding.personalPlan.plan.privacy')}
            </a>{' '}
            and{' '}
            <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
          </span>
        </Typography>
      </div>
      {showEmailPopup && <EmailPopup isOpen={isEmailPopupOpen} onClose={handleEmailPopupClose} />}

      {showGiftPopup && <GiftPopup isOpen={isGiftPopupOpen} onClose={handleGiftPopupClose} />}
    </>
  );
};

export default Paywall;
